import React from 'react';

interface Props {
  children: React.ReactNode;
  title?: string;
  className?: string;
}

const PrimarySection = ({ children, className = '', title = '' }: Props) => {
  return (
    <div
      className={`w-full space-y-4 rounded border bg-card text-card-foreground px-4 pb-4 pt-6 ${className}`}
    >
      <h3 className="mb-6 text-center text-xl font-bold">{title}</h3>
      {children}
    </div>
  );
};

export default PrimarySection;
